import React from 'react'
import AddNewOfficials from './AddNewOfficials';
import AddBreadCrumb from './AddBreadCrumb';
function AddOfficialsPage() {
    return ( 
        <div className = "container-fluid">
        <AddBreadCrumb />
        <AddNewOfficials />
        </div>
     );
}

export default AddOfficialsPage;